<template>
  <v-layout row>
    <v-flex>
      <v-card max-width="800" class="mx-auto">
        <v-layout wrap align-center justify-space-around>
          <v-flex xs2 md2>
            <v-img :src="images.profileIMG"></v-img>
          </v-flex>
          <v-divider vertical class="hidden-sm-and-down"></v-divider>
          <v-flex xs12 md7 align-center>
            <v-card-title class="headline justify-center" style="color:#0b2b49">{{hotel.name}}</v-card-title>
            <v-list>
              <v-list-tile @click="callPhone(hotel.mobile_short)">
                <v-list-tile-action>
                  <v-icon color="#a79462">mobile_friendly</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                  <v-list-tile-title>{{hotel.mobile_short}}</v-list-tile-title>
                  <!-- <v-list-tile-sub-title>Mobile Short</v-list-tile-sub-title> -->
                </v-list-tile-content>
              </v-list-tile>
              <v-divider></v-divider>
              <v-list-tile @click="callPhone(hotel.mobile)">
                <v-list-tile-action>
                  <v-icon color="#a79462">mobile_friendly</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                  <v-list-tile-title>{{hotel.mobile}}</v-list-tile-title>
                  <!-- <v-list-tile-sub-title>Mobile Short</v-list-tile-sub-title> -->
                </v-list-tile-content>
              </v-list-tile>
              <v-divider></v-divider>
              <v-list-tile @click="callPhone(hotel.landline)">
                <v-list-tile-action>
                  <v-icon color="#a79462">phone</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                  <v-list-tile-title>{{hotel.landline}}</v-list-tile-title>
                  <!-- <v-list-tile-sub-title>Mobile Short</v-list-tile-sub-title> -->
                </v-list-tile-content>
              </v-list-tile>
              <v-divider></v-divider>
              <v-list-tile @click="mailTo(hotel.email)">
                <v-list-tile-action>
                  <v-icon color="#a79462">email</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                  <v-list-tile-title>{{hotel.email}}</v-list-tile-title>
                  <!-- <v-list-tile-sub-title>Mobile Short</v-list-tile-sub-title> -->
                </v-list-tile-content>
              </v-list-tile>
              <v-divider></v-divider>
              <v-list-tile @click>
                <v-list-tile-action>
                  <v-icon color="#a79462">place</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                  <v-list-tile-title>{{hotel.sector}} - {{hotel.area}}</v-list-tile-title>
                  <!-- <v-list-tile-sub-title>Mobile Short</v-list-tile-sub-title> -->
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-flex>
        </v-layout>
        <v-flex xs12 v-if="isAdmin" style="text-align:center;">
        <v-btn flat fab color="lime">
          <v-icon>create</v-icon>
        </v-btn>
        <v-btn class="justify-center" flat fab color="lime" @click.stop="dialog = true">
          <v-icon>delete_outline</v-icon>
        </v-btn>
        <v-dialog v-model="dialog" max-width="290">
          <v-card>
            <v-card-title class="headline justify-center">
              You seem harsh!
              <br />Delete hotel?
            </v-card-title>

            <v-card-text>We both know this cannot be undone...</v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>

              <v-btn color="red darken-1" dark text @click="dialog = false">OMG No!</v-btn>

              <v-btn color="green" dark text @click="onDelete(hotel.id)">Go on</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-flex>
      </v-card>
      
      <v-layout>
        <v-btn bottom right fixed fab color="lime" router to="/HotelList">
          <v-icon>arrow_back</v-icon>
        </v-btn>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  data() {
    return {
      dialog: false,
      images: {
        profileIMG: require("@/assets/aegeo_logo_blue.jpg")
      }
    };
  },
  props: ["id"],
  computed: {
    hotel() {
      return this.$store.getters.loadedHotel(this.id);
    },
    isAdmin() {
      if (this.$store.getters.user.id === "l0GxQQzn9iTs5phuG7FvifWvorR2") {
        return true;
      } else {
        return false;
      }
    }
  },
  methods: {
    editHotel(id) {
      this.$router.push("/EditHotel/" + id);
    },
    mailTo(email) {
      if (email !== "") {
        window.open("mailto:" + email);
      } else {
        alert("There is no email!");
      }
    },
    callPhone(phone) {
      if (phone !== "") {
        window.open("tel:" + phone);
      } else alert("There is no phone!");
    },
    onDelete(hotelID) {
      this.$store.dispatch("deleteHotel", hotelID);
      this.$router.push("/");
    }
  }
};
</script>